module.exports = __webpack_public_path__ + "static/map-2da79949a1e31f5864700f9fdb18c947.png";